import styled from 'styled-components';

import {Label} from 'components/ui-kit/Label';
import {border, buttonReset, colors} from 'theme';

export const CustomButton = styled.button`
    ${buttonReset};
    background: ${colors.white};
    border: 1px solid ${colors.border};
    border-radius: ${border.radius};
    min-height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 10px 2px 8px;
    font-size: 14px;
    color: ${colors.textPrimary};

    &:focus {
        outline: none;
        border-color: ${colors.brandPrimary};

        &:hover {
            border-color: ${colors.brandPrimary};
        }
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: flex-end;
    padding-top: 20px;
`;

export const CustomLabel = styled(Label)`
    margin-top: 12px;
`;
